module.exports = __webpack_public_path__ + "static/media/teetasu.ae911251.png";